import React, { useState } from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './profile.style.scss';
import { Link, NavLink, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { RoutePath } from '../../../data';
import UserDetail from './userDetail/userdetail.index';
import LoginDetail from './loginDetail/logindetail.index';
import ChangePassword from './changePassword/changePassword.index';

const Profile: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.profile;
    const history = useHistory<any>();
    const [hideHeader, setHide] = useState(false);

    return (
        <div className="kiosk-profile-page">
            {hideHeader ? (
                <></>
            ) : (
                <>
                    <div className="header">
                        <i onClick={() => history.push(RoutePath.dashboard.index)} className="material-icons">
                            arrow_forward
                        </i>
                        <Link className="header-text" to="#">
                            {lang.profile}
                        </Link>
                    </div>
                    <div className="title-button">
                        <NavLink
                            to={RoutePath.dashboard.profile.userDetail}
                            activeClassName="active"
                            className="items border"
                        >
                            <div className="text">
                                <i className="material-icons">description</i>
                                {lang.userDetail}
                            </div>
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            to={RoutePath.dashboard.profile.loginDetail}
                            className="items"
                        >
                            <div className="text">
                                <i className="material-icons">login</i>
                                {lang.loginDetail}
                            </div>
                        </NavLink>
                    </div>{' '}
                </>
            )}
            <div className="content">
                <Switch>
                    <Route path={RoutePath.dashboard.profile.changePassword}>
                        <ChangePassword hide={setHide} />
                    </Route>
                    <Route path={RoutePath.dashboard.profile.userDetail} component={UserDetail} />
                    <Route path={RoutePath.dashboard.profile.loginDetail} component={LoginDetail} />
                    <Route path="*">
                        <Redirect to={RoutePath.dashboard.profile.userDetail} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Profile);
